module.exports = __webpack_public_path__ + "static/media/moneyWorld.9bbfc92c.svg";